import React, { useEffect, useState } from 'react'
import { useMoralis } from 'react-moralis'
import UserIdenticon from '../commons/UserIdenticon'
import { getEllipsisTxt } from '../../helpers/formatters'
import { Link } from '@reach/router';

const NavLink = props => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? 'active' : 'non-active',
      };
    }}
  />
);


export default function CreatorsList() {

  const [creatorsList, setCreatorsList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { Moralis, isInitialized } = useMoralis()

  const getUserImage = (moralisAttributes) => {
    if ("profileImageCID" in moralisAttributes && moralisAttributes.profileImageCID != null) {
      const profileImageUrl = `https://hodl4gold.mypinata.cloud/ipfs/${moralisAttributes.profileImageCID}`
      return <img className="profile-image" src={profileImageUrl} alt="" />
    } else {
      return <UserIdenticon size="50" walletAddress={moralisAttributes.walletAddress} />
    }
  }

  const getUsername = (moralisAttributes) => {

    if (moralisAttributes) {
      if ("username" in moralisAttributes && moralisAttributes.username !== "") {
        return moralisAttributes.username
      } else {
        return getEllipsisTxt(moralisAttributes.walletAddress, 7)
      }
    } else {
      return getEllipsisTxt(moralisAttributes.walletAddress, 7)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {

    try {
      if (isInitialized) {
        setIsLoading(true)
        const params = { limit: 10 };
        const topCreators = await Moralis.Cloud.run("getTopCreators", params);
        setCreatorsList(topCreators)
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      console.error("MORALIS : error while fetching top sellers ", error)

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  return (
    <div>
      {
        isLoading ? (
          <div className='row'>
            <div className='col-lg-12'>
              <div className='loading-container'>
                <div className="spinner-grow" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>

        ) :
          (
            <div className='row'>
              {
                creatorsList && creatorsList.length > 0 ? (
                  creatorsList.map((item, index) => (
                    <div className='col-sm-12 col-md-6 col-lg-6 col-xl-3 seller-container' key={index}>

                      <div className='row'>
                        <div className='col-sm-2 col-md-2 col-lg-2'>
                          <div className="author_list_pp">
                            <span onClick={() => window.open("", "_self")}>
                              {getUserImage(item.attributes)}
                              <i className="fa fa-check"></i>
                            </span>
                          </div>
                        </div>

                        <div className='col-sm-10 col-md-10 col-lg-10'>
                          <div className='sellers-metadata'>
                            <div className='author-list'>
                              <div className="user-name">
                                <span onClick={() => window.open("", "_self")}>
                                  <NavLink to={`/creator-profile/${item.attributes.walletAddress}`}>
                                    {getUsername(item ? item.attributes : null)}
                                  </NavLink>
                                </span>
                                <br />
                                <span className="bot">Top Seller</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='col-sm-12'>
                    <div className='loading-container'>
                      No sellers found
                    </div>
                  </div>

                )
              }
            </div>
          )

      }
    </div>
  )
}
